import {Component, computed, inject, input} from '@angular/core';
import {EvenementPlanning} from '../model/evenement-planning.model';
import {TypeEvenement} from '../../shared/models/type-evenement.model';
import {TranslateService} from '@ngx-translate/core';
import {Duree} from '../../shared/models/duree.model';

@Component({
	selector: 'app-evenement-planning',
	templateUrl: './evenement-planning.component.html',
	styleUrl: './evenement-planning.component.scss'
})
export class EvenementPlanningComponent {
	evenementsPlannings = input.required<EvenementPlanning[]>();
	typeEvenement = input.required<TypeEvenement>();
	site = input<string>();

	iconeEvenement = computed(() => {
		switch (this.typeEvenement()) {
			case TypeEvenement.BUREAU:
				return 'pi-briefcase';
			case TypeEvenement.TELETRAVAIL:
				return 'pi-home';
			case TypeEvenement.CONGE:
				return 'pi-sun';
			case TypeEvenement.TRAVAILLE_AILLEURS:
				return 'pi-globe';
		}
	});

	titreSection = computed(() => {
		// si le site est défini, on affiche le nom de site de manière lisible
		// sinon on affiche le type d'événement
		if (this.site() != null) {
			if (this.site() === '') {
				return this.translateService.instant('PLANNING.TITRE_SECTION_BUREAU_NON_RESERVE');
			}
			else if (this.site().toLowerCase().startsWith(this.translateService.instant('PLANNING.TITRE_SECTION_PREFIXE_SITE').toLowerCase())) {
				return this.site();
			}
			return this.translateService.instant('PLANNING.TITRE_SECTION_PREFIXE_SITE') + ' ' + this.site();
		}
		else {
			return this.translateService.instant(`PLANNING.TITRE_SECTION_EVENEMENT_${this.typeEvenement()}`);
		}
	});

	private translateService = inject(TranslateService);
	protected readonly Duree = Duree;
}
